<template>
  <v-layout row wrap>
    <v-flex xs12 lg8 class="pa-2" style="padding: 8px 8px 8px 0px !important;">
      <v-card class="soft-card pa-4">
        <v-layout row wrap align-center justify-space-between>
          <div>
            <div class="section-heading">Accounts Breakdown</div>
            <div class="muted body-2">Each child syndicate account with profit, payout, and balance to date.</div>
          </div>
          <v-btn small color="green darken-2" dark class="export-btn" :loading="exporting" @click="exportExcel">
            <v-icon small left>grid_on</v-icon>Excel
          </v-btn>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 md6 class="pa-2" v-for="item in accountBreakdown" :key="item.account">
            <v-card flat class="panel-muted pa-4">
              <v-layout row justify-space-between align-start class="mb-3" style="margin-bottom: 14px !important;">
                <div>
                  <div class="bold-dark">{{ item.account }}</div>
                  <div class="caption muted">{{ item.deals }} deals</div>
                </div>
                <StatusChip v-if="item.status" :status="item.status" />
              </v-layout>
              <v-layout row wrap>
                <v-flex xs6 class="mb-3" style="margin-bottom: 12px !important;" v-for="field in accountCardFields(item)" :key="field.label">
                  <div class="stat-label">{{ field.label }}</div>
                  <div :class="field.className">
                    <template v-if="field.value === null || field.value === undefined">—</template>
                    <template v-else>{{ field.value | currency }}</template>
                  </div>
                </v-flex>
              </v-layout>
              <v-layout row justify-space-between class="caption font-weight-bold muted mb-1">
                <span>Total Payouts against Expected RTR</span><span>{{ percentCollected(item) }}%</span>
              </v-layout>
              <div class="mini-bar"><span :style="{ width: percentCollected(item) + '%' }"></span></div>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>

    <v-flex xs12 lg4 class="pa-2" style="padding: 8px 0px 8px 8px !important;">
      <SuperSyndicatePayouts :syndication-id="syndicationId" />
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios'
import { URL } from '../../../env'
import StatusChip from './StatusChip'
import SuperSyndicatePayouts from './SuperSyndicatePayouts'

export default {
  components: {
    StatusChip,
    SuperSyndicatePayouts,
  },
  // syndicationId is only forwarded to the payouts panel; the breakdown itself
  // is keyed by user_id and is fetched once on mount (never on switch).
  props: {
    syndicationId: { default: null },
  },
  data() {
    return {
      user_id: localStorage.getItem('user_id'),
      accountBreakdown: [],
      exporting: false,
    };
  },
  mounted() {
    this.getAccountBreakdown();
  },
  methods: {
    getAccountBreakdown: function () {
      if (!this.user_id) return;
      // The breakdown is keyed by user_id and is identical regardless of which
      // syndicate is selected. It's fetched once on mount; switching syndicates
      // no longer reloads the page, so this component stays mounted and never
      // re-fetches — one API call for the life of the page.
      axios.get(`${URL}/api/payouts/super_syndicate_breakdown/${this.user_id}`)
        .then(res => { this.accountBreakdown = (res.data && res.data.accounts) || []; });
    },
    exportExcel: function () {
      if (!this.user_id) return;
      this.exporting = true;
      axios({
        url: `${URL}/api/payouts/super_syndicate_breakdown/${this.user_id}`,
        method: 'GET',
        responseType: 'blob',
        params: { export: 1 },
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'account_breakdown.xlsx');
        document.body.appendChild(link);
        link.click();
        this.exporting = false;
      }).catch(() => { this.exporting = false; });
    },
    accountCardFields: function (item) {
      return [
        { label:'Capital Participated', value:item.invested, className:'bold-dark' },
        { label:'Expected RTR (Return)', value:item.expectedReturn, className:'bold-dark' },
        { label:'Projected Profit', value:item.projectedProfit, className:'blue-text-custom' },
        { label:'Actual Profit', value:item.actualProfit, className:'green-text-custom' },
        { label:'Total Payouts', value:item.payoutDue, className:'bold-dark' },
        { label:'Outstanding Balance', value:item.outstandingBalance, className:'violet-text-custom' }
      ];
    },
    percentCollected: function (item) {
      // Total Payouts against expected (part) RTR, to 1 decimal (e.g. 34.5).
      if (!item.expectedReturn) return 0;
      return Math.round((item.payoutDue / item.expectedReturn) * 1000) / 10;
    }
  }
};
</script>

<style scoped src="./Styles/SuperSyndicate.css"></style>
